var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartTheaterModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.5H3C1.9 3.5 1 4.4 1 5.5V17.5C1 18.6 1.9 19.5 3 19.5H8V21.5H16V19.5H21C22.1 19.5 22.99 18.6 22.99 17.5L23 5.5C23 4.4 22.1 3.5 21 3.5ZM21 17.5H3V5.5H21V17.5Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.5L13 11.5L18 16.5V6.5Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5L11 11.5L6 6.5L6 16.5Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartTheaterModeIcon);
export default __webpack_public_path__ + "static/media/start_theater_mode_icon.787a5912.svg";
export { ForwardRef as ReactComponent };